module.exports = __webpack_public_path__ + "static/media/icon-code-of-practice-no-information.4e52c4ec.png";